//  +----------------------------------------------------------------------
//  | 球友会 [ 关于台球，就用球友汇 ]
//  +----------------------------------------------------------------------
//  | Copyright (c) 2025 https://www.qyxtyfz.com All rights reserved.
//  +----------------------------------------------------------------------

/**
 * 验证小数点后两位及多个小数
 * money 金额
 */
export function isMoney(money) {
	var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
	if (reg.test(money)) {
		return true
	} else {
		return false
	}
}

/**
 * 验证手机号码
 * money 金额
 */
export function checkPhone(phone) {
	var reg = /^1(3|4|5|6|7|8|9)\d{9}$/
	if (reg.test(phone)) {
		return true
	} else {
		return false
	}
}

/**
 * 函数防抖 (只执行最后一次点击)
 * @param fn
 * @param delay
 * @returns {Function}
 * @constructor
 */
export const Debounce = (fn, t) => {
	const delay = t || 500
	let timer
	return function() {
		const args = arguments
		if (timer) {
			clearTimeout(timer)
		}
		timer = setTimeout(() => {
			timer = null
			fn.apply(this, args)
		}, delay)
	}
}

// 节流函数,延时执行和立即执行

export function throttle(fn, delay,isNow) {
	if (isNow) {
		let lastTime = 0;
		  return function(...args) {
		    const now = Date.now();
		    if (now - lastTime >= delay) {
		      fn.apply(this, args);
		      lastTime = now;
		    }
		  };
	} else {
		var lastArgs;
		var timer;
		var delay = delay || 200;
		return function(...args) {
			lastArgs = args;
			if (!timer) {
				timer = setTimeout(() => {
					timer = null;
					fn.apply(this, lastArgs);
				}, delay);
			}
		}
	}

}
